<template>
  <div>
    <Landing />
    <SadWindows :effectsDisabled="isDesktop ? effectsDisabled : true" />

    <div class="disable-effects" v-if="isDesktop">
      <span>Epileptic or slow computer?</span>
      <input type="checkbox" name="disable-box" :checked="effectsDisabled"><label for="disable-box" @click="effectsDisabled = !effectsDisabled">Disable effects</label>
    </div>
  </div>
</template>

<script>
import Landing from '../eov/Landing.vue'
import SadWindows from '../sad windows/SadWindows.vue'

export default {
  components: {
    Landing: Landing,
    SadWindows: SadWindows
  },
  data () {
    return {
      booted: false,
      effectsDisabled: false
    }
  },
  computed: {
    isDesktop () {
      return window.innerWidth > 1280 ? true : false
    }
  }
}
</script>

<style>
.disable-effects {
  position: absolute;
  bottom: 25px;
  left: 50vw;
  transform: translateX(-50%);
  font-size: 180%;
  line-height: 54px;
  font-family: "Open Sans", Arial, sans-serif;
  color: #111;
}

.disable-effects input[type="checkbox"]:checked,
.disable-effects input[type="checkbox"]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.disable-effects input[type="checkbox"]:checked + label,
.disable-effects input[type="checkbox"]:not(:checked) + label {
  display: block;
  position: relative;
  cursor: pointer;
}

.disable-effects input[type="checkbox"]:checked + label:before,
.disable-effects input[type="checkbox"]:not(:checked) + label:before {
  display: block;
  content: '';
  position: absolute;
  top: 12px;
  right: 0px;
  width: 56px;
  height: 28px;
  border-radius: 14px;
  box-shadow: inset 2px 2px 2px #444
}

.disable-effects input[type="checkbox"]:checked + label:after,
.disable-effects input[type="checkbox"]:not(:checked) + label:after {
  display: block;
  content: '';
  position: absolute;
  top: 12px;
  width: 28px;
  height: 28px;
  border-radius: 14px;
  background-color: #DDD;
  box-shadow: 2px 2px 2px #666
}

.disable-effects input[type="checkbox"]:not(:checked) + label:before {
  background-color: #999;
  transition: background-color 0.2s;
}

.disable-effects input[type="checkbox"]:not(:checked) + label:after {
  right: 28px;
  transition: right 0.2s;
}

.disable-effects input[type="checkbox"]:checked + label:before {
  background-color: #5B6;
  box-shadow: inset 2px 2px 2px #484;
  transition: background-color 0.2s box-shadow 0.2s;
}

.disable-effects input[type="checkbox"]:checked + label:after {
  right: 0px;
  transition: right 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/assets/home/Home.vue